/* eslint-disable max-lines */
import { sendEvents } from '@events/sendAnalytics';
import { segment } from '@actions/analytics';
import { CHECKOUT_ORDER_CREATED } from '@constants/segment';
import {
  subscriptionTypes as subscriptionTypesMap,
  evtNameCategoryMap
} from '@constants/index';
import { subscriptionTypes } from '../constants';

export const fetchPricings = (
  uid,
  isIconic = false,
  // eslint-disable-next-line no-unused-vars
  isUpgrade = false,
  noCache = false
) => (dispatch) => {
  const timeParam = noCache ? `&time=${Date.now()}` : '';
  return dispatch({
    type: subscriptionTypes.FETCH_PRICINGS,
    endpoint: `v3/subscriptions/?goal=${uid}&v=3&iconic=${isIconic}&upgrade=true${timeParam}`,
    method: 'get',
    uid
  });
};

export const validateReferralAll = (
  referral,
  goal,
  scheme = 2,
  isIconic = false,
  // eslint-disable-next-line no-unused-vars
  isUpgrade = false
) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.VALIDATE_REFERRAL,
    endpoint: `v2/subscriptions/validate_referral_all_subscriptions/?referral=${encodeURIComponent(
      referral
    )}&goal=${goal}&iconic=${isIconic}&upgrade=true&scheme=${scheme}`,
    method: 'get',
    uid: goal
  });

export const validateReferralAllWithSubscriptionId = (
  referral,
  subscriptionId,
  goal,
  scheme = 2,
  isIconic = false,
  // eslint-disable-next-line no-unused-vars
  isUpgrade = false
) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.VALIDATE_REFERRAL_WITH_SUBSCRIPTION_ID,
    endpoint: `v2/subscriptions/validate_referral_all_subscriptions/?referral=${referral}&iconic=${isIconic}&upgrade=true&goal=${goal}&scheme=${scheme}`,
    method: 'get',
    uid: goal,
    subscriptionId
  });

export const validateReferral = (
  referralId,
  subscriptionId,
  goalId,
  scheme = 2,
  isIconic = false,
  // eslint-disable-next-line no-unused-vars
  isUpgrade = false
) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.VALIDATE_REFERRAL_SUBSCRIPTION,
    endpoint: `v2/subscriptions/validate_referral/?&iconic=${isIconic}&upgrade=true`,
    method: 'post',
    data: {
      referral: referralId,
      subscription: subscriptionId,
      scheme
    },
    uid: goalId
  });

export const clearReferralError = () => (dispatch) =>
  dispatch({
    type: subscriptionTypes.CLEAR_REFERRAL_ERROR
  });

export const resetReferralPricings = (goalUid) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.CLEAR_REFERRAL_PRICINGS,
    uid: goalUid
  });

export const resetReferralSubscription = (goalUid) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.CLEAR_REFERRAL_SUBSCRIPTION,
    uid: goalUid
  });

export const fetchPaymentMethods = () => (dispatch) =>
  dispatch({
    type: subscriptionTypes.FETCH_PAYMENT_METHODS,
    endpoint: 'v1/payments/juspay/payment_methods/?version=2',
    method: 'get'
  });

export const fetchSavedCards = () => (dispatch) =>
  dispatch({
    type: subscriptionTypes.FETCH_SAVED_CARDS,
    endpoint: 'v1/payments/juspay/cards/',
    method: 'get'
  });

export const fetchEMIPlans = () => (dispatch) =>
  dispatch({
    type: subscriptionTypes.FETCH_EMI_PLANS,
    endpoint: 'v1/payments/emi_plans/?version=2',
    method: 'get'
  });

export const fetchPartPaymentStatus = (goalUid) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.FETCH_PART_PAYMENT_STATUS,
    key: goalUid,
    endpoint: `v2/subscriptions/part_payment_status?goal_uid=${goalUid}&extra_data=1`,
    method: 'get'
  });

function getAmount(data) {
  return Math.round(data?.reduce((acc, _val) => acc + _val.amount, 0) ?? 0);
}

function orderCreatedAnalytics(info) {
  const {
    creditsApplied,
    referralCode,
    paymentMethod,
    isPartial = false,
    parts = null,
    subscription = {},
    me = {},
    selectedGoal = {},
    data,
    pipIndex,
    paymentDetails = [],
    isCombo,
    comboId,
    comboName,
    referralError,
    selectedMethod,
    purchaseType
  } = info;
  const eventData = {
    name: 'Plus: Order Created',
    Amount: isPartial
      ? getAmount(paymentDetails)
      : Math.round(data.amount / 100),
    'Partial Amount': isPartial
      ? Math.round(paymentDetails[pipIndex - 1]?.amount ?? 0)
      : Math.round(data.amount / 100 ?? 0),
    'Has Referral Code': !!referralCode,
    'Referral Code': referralCode,
    'Has Applied Credits': !!creditsApplied,
    'Subscription Duration': subscription.duration,
    'Payment Gateway': paymentMethod,
    'Subscription Type': subscription?.type,
    'Is Part Payment': isPartial,
    'Opted Part Payments': parts,
    'Order Id': data.order_id,
    'Goal Id': selectedGoal?.uid,
    'Goal Name': selectedGoal?.name,
    'Learner Id': me?.uid,
    'Learner Username': me?.username,
    'Is Combo': isCombo
  };
  if (isCombo) {
    eventData['Combo Id'] = comboId;
    eventData['Combo Name'] = comboName;
  }
  if (isPartial) {
    eventData['Current Part Payment Index'] = pipIndex;
  }
  sendEvents('Plus: Order Created', eventData);

  const segmentEventData = {
    purchase_type: purchaseType,
    subscription_type:
      subscription.type === subscriptionTypesMap.ICONIC ? 'Iconic' : 'Plus',
    subscription_duration: subscription?.duration,
    price: isPartial
      ? getAmount(paymentDetails)
      : Math.round(data.amount / 100),
    referral_code: referralCode,
    is_referral_successful: Boolean(referralCode) && !referralError,
    has_applied_credits: creditsApplied,
    credits_applied:
      (creditsApplied && subscription?.redeemable_credit_amount) || 0,
    is_partpayment: isPartial,
    payment_gateway: selectedMethod
  };
  segment.track(
    CHECKOUT_ORDER_CREATED,
    segmentEventData,
    evtNameCategoryMap.BOTH
  );
}

export const enrollOrderJuspay = (
  subscriptionId,
  creditsApplied,
  phoneNumber,
  referralCode,
  paymentMethod,
  paymentMethodType,
  emiData,
  gateway = 2,
  isPartial = false,
  parts = 0,
  {
    subscription = {},
    me = {},
    selectedGoal = {},
    pipIndex,
    paymentDetails = []
  },
  isCombo,
  comboId,
  comboName,
  referralError,
  selectedMethod,
  purchaseType,
  cashBank
) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.ENROLL_ORDER,
    endpoint: `v1/subscriptions/order/${subscriptionId}/`,
    method: 'post',
    data: {
      renew: false,
      referral: referralCode || null,
      phone: phoneNumber,
      scheme: 2,
      use_credits: creditsApplied,
      payment_method: paymentMethod,
      payment_method_type: paymentMethodType,
      emi_data: emiData,
      gateway,
      upgrade: true,
      is_partial: isPartial,
      no_of_installments: parts,
      return_url: process.env.PAYMENT_RETURN_URL,
      bank_name: cashBank
    },
    isCashPayment: gateway === 8,
    callback: (data) => {
      orderCreatedAnalytics({
        subscriptionId,
        creditsApplied,
        phoneNumber,
        referralCode,
        paymentMethod,
        paymentMethodType,
        emiData,
        isPartial,
        parts,
        subscription,
        me,
        selectedGoal,
        data,
        pipIndex,
        paymentDetails,
        isCombo,
        comboId,
        comboName,
        referralError,
        selectedMethod,
        purchaseType
      });
    }
  });

export const enrollInstallmentOrderJuspay = (
  subscriptionId,
  creditsApplied,
  phoneNumber,
  referralCode,
  paymentMethod,
  paymentMethodType,
  emiData,
  gateway = 2,
  orderUid,
  parts = 0,
  { subscription, me = {}, selectedGoal = {}, pipIndex, paymentDetails = [] },
  isCombo,
  comboId,
  comboName,
  referralError,
  selectedMethod,
  purchaseType
) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.ENROLL_INSTALLMENT_ORDER,
    endpoint: `v1/subscriptions/order/${subscriptionId}/${orderUid}`,
    method: 'post',
    data: {
      renew: false,
      referral: referralCode || null,
      phone: phoneNumber,
      scheme: 2,
      use_credits: creditsApplied,
      payment_method: paymentMethod,
      payment_method_type: paymentMethodType,
      emi_data: emiData,
      gateway,
      upgrade: true,
      return_url: process.env.PAYMENT_RETURN_URL
    },
    callback: async (data) => {
      orderCreatedAnalytics({
        subscriptionId,
        creditsApplied,
        phoneNumber,
        referralCode,
        paymentMethod,
        paymentMethodType,
        emiData,
        isPartial: true,
        parts,
        subscription,
        me,
        selectedGoal,
        data,
        pipIndex,
        paymentDetails,
        isCombo,
        comboId,
        comboName,
        referralError,
        selectedMethod,
        purchaseType
      });
    }
  });

export const clearOldOrder = () => (dispatch) =>
  dispatch({
    type: subscriptionTypes.CLEAR_ORDER
  });

export const purchaseSubscription = (orderId, gateway = 2) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.PURCHASE_SUBSCRIPTION,
    endpoint: 'v1/subscriptions/purchase/',
    method: 'post',
    data: {
      order_id: orderId,
      renew: false,
      gateway
    }
  });

export const checkForPaymentStatusJuspay = (orderId, gateway = 'juspay') => (
  dispatch
) =>
  dispatch({
    type: subscriptionTypes.PAYMENT_STATUS_JUSPAY,
    endpoint: `v1/payments/${gateway}/payment_status/?order_id=${orderId}`,
    method: 'get'
  });

export const savePurchasedSubscription = (
  goalOrComboId,
  orderId,
  purchasedSubscription
) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.SAVE_PURCHASED_SUBSCRIPTION,
    goalOrComboId,
    orderId,
    purchasedSubscription
  });

export const subscribeToExternalApp = (url, goalUID) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.ACTIVATE_EXTERNAL_APP,
    endpoint: url,
    key: goalUID,
    method: 'post'
  });

export const fetchPartPaymentsInfos = () => (dispatch) =>
  dispatch({
    type: subscriptionTypes.FETCH_PART_PAYMENTS_INFOS,
    endpoint: 'part-payments-infos',
    method: 'get',
    isCMS: true
  });

export const fetchPartPaymentsFaqs = () => (dispatch) =>
  dispatch({
    type: subscriptionTypes.FETCH_PART_PAYMENTS_FAQS,
    endpoint: 'v1/subscriptions/part_payment_faq',
    method: 'get'
  });

export const stopPartPaymentNudges = (subscriptionId) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.STOP_PART_PAYMENT_NUDGE,
    endpoint: `v1/users/visit_screen/part_payment_refund_screen/${subscriptionId}/`,
    method: 'post'
  });

export const hidePartPaymentNudge = () => ({
  type: subscriptionTypes.HIDE_PART_PAYMENT_NUDGE
});

export const activateExternalSubscription = (code, state, app_name) => (
  dispatch
) =>
  dispatch({
    type: subscriptionTypes.SYNC_CODE_CHEF,
    endpoint: 'v1/subscriptions/activate_external_subscription',
    data: {
      code,
      state,
      app_name
    },
    method: 'post'
  });

export const fetchLoanLearnerDetails = (learnerUID) => ({
  type: subscriptionTypes.FETCH_LOAN_LEARNER_DETAILS,
  method: 'get',
  endpoint: `v1/users/${learnerUID}/subscriptions/internal/?scope=loans`
});

export const fetchEligibleGoals = (key) => ({
  type: subscriptionTypes.FETCH_ELIGIBLE_GOALS,
  method: 'get',
  endpoint: `v1/subscriptions/${key}/goals`
});

export const submitLoanData = (data, duration) => ({
  type: subscriptionTypes.SUBMIT_LOAN_DATA,
  endpoint: `v1/subscriptions/loan_quote/${duration}`,
  method: 'post',
  data
});

export const submitCashPaymentData = (data, subscriptionId) => ({
  type: subscriptionTypes.SUBMIT_CASH_DEPOSIT_DATA,
  endpoint: `v1/subscriptions/cash_deposit_order/${subscriptionId}/`,
  method: 'post',
  data
});

export const fetchEligibleSubscriptions = (goalUID, learnerUID) => ({
  type: subscriptionTypes.FETCH_ELIGIBLE_SUBSCRIPTIONS,
  method: 'get',
  endpoint: `v2/subscriptions/loan_info/subscriptions?goal_uid=${goalUID}&upgrade=true&iconic=True&learner_uid=${learnerUID}`
});

export const fetchEligibleSubscriptionsForCash = (goalUID, learnerUID) => ({
  type: subscriptionTypes.FETCH_ELIGIBLE_SUBSCRIPTIONS_FOR_CASH_PAYMENT,
  method: 'get',
  endpoint: `v1/subscriptions/cash_deposit_info/subscriptions?goal_uid=${goalUID}&user_uid=${learnerUID}`
});

export const validateCashReferral = (data) => ({
  type: subscriptionTypes.VALIDATE_CASH_REFERRAL,
  endpoint:
    'v1/subscriptions/cash_deposit_info/validate_referral/?upgrade=true',
  method: 'post',
  data
});

export const fetchBundleDetails = (uid) => ({
  type: subscriptionTypes.FETCH_BUNDLE_DETAILS,
  uid,
  method: 'get',
  endpoint: `v1/subscriptions/bundle/${uid}/details`
});

export const fetchCheckoutStaticData = (key) => (dispatch) =>
  dispatch({
    type: subscriptionTypes.FETCH_SUBSCRIPTION_STATIC_DATA,
    endpoint: `checkout-static-data/${key}`,
    key,
    method: 'get',
    isCMS: true
  });

export const fetchComboFeatures = (goalUIDs = []) => {
  const goal_uid_string = goalUIDs
    .map((goal) => `goalUID_in=${goal}&`)
    .join('');
  return {
    type: subscriptionTypes.FETCH_COMBO_FEATURE_POINTS,
    endpoint: `api/combo-goal-properties?${goal_uid_string}`,
    method: 'get',
    isCMS: true
  };
};

export const validateVPA = (upiId) => ({
  type: subscriptionTypes.VERIFY_VPA,
  endpoint: 'v1/payments/juspay/verify_vpa/',
  method: 'post',
  data: {
    vpa: upiId
  }
});

export const fetchUPISuffixList = () => ({
  type: subscriptionTypes.FETCH_UPI_SUFFIX_LIST,
  endpoint: 'api/upi-collect',
  method: 'get',
  isCMS: true
});

export const verifyDCEMIEligibility = ({ phoneNo, bankId, amount }) => ({
  type: subscriptionTypes.VERIFY_DC_EMI_ELIGIBILITY,
  endpoint: `v1/payments/dc_emi/eligibility/?phone=${phoneNo}&bank=${bankId}&amount=${amount}`,
  method: 'get'
});

export const fetchCardBankAliases = () => ({
  type: subscriptionTypes.FETCH_CARD_BANK_ALIASES,
  endpoint: 'api/card-brands-to-banks',
  method: 'get',
  isCMS: true
});

export const fetchAllPaymentMethods = (subscriptionUID) => ({
  type: subscriptionTypes.FETCH_ALL_PAYMENT_METHODS,
  endpoint: `v1/payments/all_gateways/payment_methods/?subscription_uid=${subscriptionUID}`,
  method: 'get'
});

export const fetchCashPaymentStatus = (goalUID) => ({
  type: subscriptionTypes.FETCH_CASH_PAYMENT_DATA,
  endpoint: `v2/subscriptions/cash_payment_status/?goal_uid=${goalUID}`,
  method: 'get'
});

export const cancelCashPayment = (orderId) => ({
  type: subscriptionTypes.CANCEL_CASH_PAYMENT,
  endpoint: 'v1/payments/isure/cancel/',
  method: 'post',
  data: {
    order_id: orderId,
    gateway: 8
  }
});

export const resetCashResponseData = () => ({
  type: subscriptionTypes.RESET_CASH_RESPONSE
});
